import React, { Fragment, Component } from 'react';
import PropTypes from 'prop-types';
import * as types from '../../../constants/actionTypes';
import { Routes } from '../../../constants/routes';
import { DATE_FORMAT, QUICK_LINK_TYPES } from '../../../constants/constants';
import { CUSTOMER_ROLES } from '../../../constants/roles';
import Moment from 'moment';
import StatusLegend from '../../Common/StatusLegend/StatusLegend';
import BarCard from '../../Common/BarCard/BarCard';
import LoadingIndicator from '../../Common/LoadingIndicator/LoadingIndicator';
import Notification from '../../Common/Notification';
import Icon from '../../Common/Icon';
import Button from '../../Common/Button';
import Graph100StackedBar from '../../Common/Graph100StackedBar';
import { NavigateToRouteWithDashboardParams } from '../../../helpers/routing';
import ProjectsWidgetDrawer from './ProjectsWidgetDrawer';
import AddSingleLocProjectDrawer from './AddSingleLocProjectDrawer';
import './Projects.scss';
import LocationTaskDetailDrawer from '../../TaskList/TaskDetail/LocationTaskDetailDrawer';
import { actions as locationTaskActions } from '../../../actions/locationTaskActions';
import { actions as filesActions } from '../../../actions/filesActions';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import FileTypeIcon from '../../Common/FileTypeIcon';
import LabelTagDisplay from './LabelTagDisplay';

export const MODES = {
	Limited: 1,
	Add: 2,
	Edit: 3,
};

export class Projects extends Component {
	constructor(props, context) {
		super(props, context);

		const task = {
			additionalInfo: '',
			anticipatedEffort: '',
			baselineId: 0,
			baselineTaskId: 0,
			communityId: 0,
			contactEmail: '',
			contactName: '',
			contingentId: '',
			contingentTaskName: '',
			contingentTaskStatus: '',
			contingentTaskCoreStatusId: 0,
			comment: '',
			comments: [],
			commentTotal: 0,
			communityName: '',
			createdByUserId: 0,
			createdDate: '',
			departmentId: 0,
			departmentName: '',
			financialsBudget: '',
			financialsActual: '',
			files: [],
			history: [],
			id: 0,
			isActive: true,
			isEditingProjectCoach: false,
			isShowingBasicInfo: false,
			isHidden: false,
			isMilestone: false,
			isProjectCertified: false,
			isLocationTaskDateAdjustable: false,
			jobTitleId: 0,
			jobTitleName: '',
			links: [],
			locationId: 0,
			locationKey: '',
			modifiedByUserId: 0,
			modifiedDate: '',
			name: '',
			ordinal: 0,
			phaseId: '',
			phaseName: '',
			projectId: '',
			projectName: '',
			projectCoachId: 0,
			projectCoach: '',
			responsibleUserId: 0,
			startDate: '',
			startDaysOut: 0,
			startWeeks: 0,
			startDays: 0,
			statusId: '',
			steps: [],
			subscriptionId: 0,
			successorId: '',
			successorTasks: [],
			targetDate: '',
			targetDaysOut: 0,
			targetWeeks: 0,
			targetDays: 0,
			locationTaskTagIds: [],
			baselineTaskTags: [],
		};

		this.state = {
			isLoading: true,
			isProjectResourcesDrawerOpen: false,
			isAddSingleLocProjectDrawerOpen: false,
			isAddTaskForLocProjectDrawerOpen: false,
			showMore: true,
			projects: [],
			selectedProjectId: null,
			searchParams: {
				pageSize: 8,
				pageNumber: 1,
				subscriptionId: this.props.subscriptionId,
				locationKey: this.props.locationKey,
			},
			task: task,
			locationUsers: [],
			locationTaskDrawerFilters: {
				isStartDateActive: false,
				isTaskStepsActive: false,
				isProjectWidgetActive: false,
				isProjectIdRequiredForLocationTask: false,
				isTaskDependenciesActive: false,
				allowLocationTaskDateChanges: false,
				completeStatusId: 0,
				locationOpeningDate: '',
				statuses: [],
				responsibleUsers: [],
				departments: [],
				communities: [],
				projects: [],
				phases: [],
				contingentTasks: [],
				successorTasks: [],
			},
		};
	}

	componentDidMount = async () => {
		if (this.props.locationKey) {
			this.loadProjects();
			this.getResponsibleUsersForLocations();
		}
	};

	componentDidUpdate(prevProps) {
		if (this.props.locationKey && this.props.locationKey !== prevProps.locationKey) {
			this.setState(
				{
					searchParams: { ...this.state.searchParams, locationKey: this.props.locationKey },
					projects: [],
					isLoading: true,
				},
				this.loadProjects
			);
		}
	}

	loadProjects = async () => {
		if (!this.props.locationKey) {
			return;
		}

		try {
			const response = await this.props.locationDashboardActions.loadProjectsByLocationSection(this.state.searchParams);
			if (response.type === types.LOAD_PROJECTS_BY_LOCATION_SUCCESS) {
				const showMore = response.payload.results.length < this.state.searchParams.pageSize ? false : true;

				// Create a set of existing project IDs for quick lookups
				const existingIds = new Set(this.state.projects.map((p) => p.id));

				// Filter out projects that already exist in state
				const newProjects = response.payload.results.filter((proj) => !existingIds.has(proj.id));

				// Concatenate only unique projects
				const combinedProjects = [...this.state.projects, ...newProjects];

				this.setState({ projects: combinedProjects, showMore: showMore });
			} else if (response.type === types.LOAD_PROJECTS_BY_LOCATION_FAILURE) {
				Notification('error', 'Error', response.payload.message);
			}
		} catch (error) {
			Notification('error', 'Error', error);
		} finally {
			this.setState({ isLoading: false });
		}
	};

	openProjectResourcesDrawer = (projectId) => {
		this.setState({ selectedProjectId: projectId, isProjectResourcesDrawerOpen: true });
	};

	openAddSingleLocProjectDrawer = () => {
		this.setState({ isAddSingleLocProjectDrawerOpen: true });
	};

	onHundyPBarClick = (dataPoint) => {
		NavigateToRouteWithDashboardParams(Routes.Tasks, dataPoint.urlParams, false);
	};

	onQuickLinkClick = (urlParams) => {
		NavigateToRouteWithDashboardParams(Routes.Tasks, urlParams, false);
	};

	onProjectClick = (project) => {
		const urlParams = {
			LocationKeys: [this.props.locationKey],
			statusId: project.defaultStatusIds,
			ProjectId: [project.id],
		};
		NavigateToRouteWithDashboardParams(Routes.Tasks, urlParams, false);
	};

	onShowMore = () => {
		const newPageNumber = this.state.searchParams.pageNumber + 1;
		this.setState({ searchParams: { ...this.state.searchParams, pageNumber: newPageNumber } }, this.loadProjects);
	};

	getTotalTasksForProject = (project) => {
		let total = 0;
		for (let i = 0; i < project.graphData.length; i++) {
			total += project.graphData[i].value;
		}
		return total;
	};

	onCompleteProjectResourcesDrawer = () => {
		this.setState(
			{
				searchParams: { ...this.state.searchParams, pageNumber: 1 },
				isProjectResourcesDrawerOpen: false,
				projects: [], // clearing out the projects because we merge them for the show more feature
				isLoading: true,
			},
			this.loadProjects
		);
	};

	onCancelProjectResourcesDrawer = () => {
		this.setState({ isProjectResourcesDrawerOpen: false });
	};

	onCompleteAddProjectDrawer = (project, baselineIds) => {
		if (project.isSingleLocationProject && baselineIds.length === 0) {
			this.triggerAddMode(project.id);

			this.setState(
				(prevState) => ({
					isAddSingleLocProjectDrawerOpen: false,
					isAddTaskForLocProjectDrawerOpen: true,
					projects: [], // Clearing out the projects because we merge them for the show more feature
					isLoading: true,
					task: {
						...prevState.task,
						projectId: project.id,
					},
				}),
				this.loadProjects
			);
		} else {
			this.setState(
				{
					isAddSingleLocProjectDrawerOpen: false,
					projects: [], // Clearing out the projects because we merge them for the show more feature
					isLoading: true,
				},
				this.loadProjects
			);
		}
	};

	onCancelAddProjectDrawer = () => {
		this.setState({ isAddSingleLocProjectDrawerOpen: false });
	};

	isCustomerAdmin = () => {
		return [CUSTOMER_ROLES.Admin.name, CUSTOMER_ROLES.Moderator.name, CUSTOMER_ROLES.Owner.name].includes(this.props.currentUser.customerRole);
	};

	shouldShowMilestones = (project) => {
		let links = project.quickLinks;
		if (links) {
			return !!links.find(({ type, total }) => type != null && type === 'Total' && total > 0);
		} else {
			return false;
		}
	};

	onLocationTaskDetailDrawerComplete = () => {
		this.setState(
			{
				isAddSingleLocProjectDrawerOpen: false,
				isAddTaskForLocProjectDrawerOpen: false,
				projects: [], // clearing out the projects because we merge them for the show more feature
				isLoading: true,
			},
			this.loadProjects
		);
	};

	onLocationTaskDetailDrawerCancel = () => {
		this.setState({ isAddTaskForLocProjectDrawerOpen: false });
	};

	getResponsibleUsersForLocations = async () => {
		try {
			const locKeys = [this.props.locationKey];
			const response = await this.props.locationTaskActions.searchResponsibleUsers(locKeys);

			if (response.type === types.SEARCH_LOCATION_TASK_RESPONSIBLE_USERS_SUCCESS) {
				this.setState({ locationUsers: response.payload.users });
			} else if (response.type === types.SEARCH_LOCATION_TASK_RESPONSIBLE_USERS_FAILURE) {
				Notification('error', 'Error', response.payload.message);
			}
		} catch (error) {
			Notification('error', 'Error', error);
		}
	};

	loadLocationTaskDrawerFilters = async () => {
		const response = await this.props.locationTaskActions.loadLocationTaskDrawerFilters(this.state.task.id, this.props.locationKey);
		if (response.type === types.LOAD_LOCATION_TASK_DRAWER_FILTERS_SUCCESS) {
			//isTaskDependenciesActive set to false because we don't need contingent tasks for a first task
			this.setState(
				{
					...this.state,
					locationTaskDrawerFilters: {
						...this.state.locationTaskDrawerFilters,
						isStartDateActive: response.payload.isStartDateActive,
						isTaskStepsActive: response.payload.isTaskStepsActive,
						isProjectWidgetActive: response.payload.isProjectWidgetActive,
						isProjectIdRequiredForLocationTask: response.payload.isProjectIdRequiredForLocationTask,
						isTaskDependenciesActive: false,
						allowLocationTaskDateChanges: response.payload.allowLocationTaskDateChanges,
						completeStatusId: response.payload.completeStatusId,
						locationOpeningDate: response.payload.locationOpeningDate,
						statuses: response.payload.statuses,
						departments: response.payload.departments,
						communities: response.payload.communities,
						projects: response.payload.projects,
						phases: response.payload.phases,
						contingentTasks: response.payload.contingentTasks,
						successorTasks: response.payload.contingentTasks, // successor and contingent drop-downs have same possible values
					},
				},
				() => {
					// When loading the add mode drawer, automatically set the status
					// to the default not started status for this subscription and set the
					// responsible user to the current user
					if (this.state.currentMode === MODES.Add) {
						this.setState((prevState) => ({
							...prevState,
							task: {
								...prevState.task,
								statusId: response.payload.defaultNotStartedStatusId,
							},
							isLoading: false,
						}));
					}
				}
			);
		} else if (response.type === types.LOAD_LOCATION_TASK_DRAWER_FILTERS_FAILURE) {
			Notification('error', 'Error', response.payload.message);
			this.onLocationTaskDetailDrawerCancel();
		}
	};

	triggerAddMode = async (projectId) => {
		try {
			this.setState({
				isLoading: true,
				currentMode: MODES.Add,
				task: {
					...this.state.task,
					// When adding a new task, we initialize the links list with
					// a single empty link value to be edited
					links: [
						{
							id: 0,
							name: '',
							url: '',
							isActive: true,
							ordinal: 0,
							isFile: false,
						},
					],
					// New tasks are by default assigned to the user creating
					// the task
					responsibleUserId: this.props.currentUser.id,
					locationKey: this.props.locationKey,
					projectId: projectId,
					allowLocationTaskDateChanges: true,
				},
			});
			await this.loadLocationTaskDrawerFilters();
			this.setState({ isLoading: false });
		} catch (error) {
			Notification('error', 'Error', error);
			this.onLocationTaskDetailDrawerCancel();
		}
	};

	showContingentDrawer = (e) => {
		e.preventDefault();
	};

	showPrereqDrawer = (e) => {
		e.preventDefault();
	};

	onTaskChange = (task) => {
		this.setState({
			...this.state,
			task: task,
		});
	};

	excelExport = async () => {
		try {
			await this.props.locationDashboardActions.exportHistoricalProjects(this.props.locationKey);
		} catch (error) {
			Notification('error', 'Error', error);
		}
	};

	render() {
		return (
			<Fragment>
				<div className='row'>
					<div className='col-12'>
						<div className='dashboard-widget-title'>Projects</div>
						<div className='float-end'>
							<StatusLegend />
						</div>
					</div>
				</div>
				<LoadingIndicator isLoading={this.state.isLoading}>
					{this.state.projects.length > 0 ? (
						<Fragment>
							<div className='row mt-2'>
								<div className='col-12'>
									{this.state.projects.map((project) => {
										return (
											<div key={project.id}>
												<BarCard handleClass={project.isCertified ? 'success' : null} backgroundColor='gray'>
													<div className='container-fluid'>
														<div className='row'>
															<div className={project.projectTagIds === undefined ? 'col-3' : 'col-2'}>
																<div className='d-block mb-3 project-title'>
																	<div onClick={() => this.onProjectClick(project)} className='project-name'>
																		{project.name}
																	</div>
																	<div className='d-inline ms-3'>
																		{Moment.duration(new Moment().diff(project.createdDate)).days() < 14 && (
																			<span className='badge'>New</span>
																		)}
																		<br />
																		<span className='project-zero-date'>
																			Based on {Moment.utc(project.zeroDate).format(DATE_FORMAT)}
																		</span>
																	</div>
																</div>
																<div className='row'>
																	{project.coachName ? (
																		<div className='col project-subtitle-coach'>
																			<Icon name='user' />
																			Coach: {project.coachName}
																			<Button
																				type='button'
																				text='Modify'
																				bootstrapClass='link'
																				name='changeCoach'
																				onClick={() => this.openProjectResourcesDrawer(project.id)}
																			/>
																		</div>
																	) : (
																		<div className='col project-subtitle-coach'>
																			<Icon name='user' /> No Coach Assigned
																			<Button
																				type='button'
																				text='Assign Coach'
																				bootstrapClass='link'
																				name='changeCoach'
																				onClick={() => this.openProjectResourcesDrawer(project.id)}
																			/>
																		</div>
																	)}
																</div>
																<div className='row'>
																	<div className='col project-subtitle'>
																		<Icon name='folder' />
																		<Button
																			type='button'
																			text='View Project Resources'
																			bootstrapClass='link'
																			name='viewResources'
																			onClick={() => this.openProjectResourcesDrawer(project.id)}
																		/>
																	</div>
																</div>
															</div>
															<div className='col-4'>
																<div className='task-title'>Tasks</div>
																<div className='task-subtitle'>
																	<strong>{this.getTotalTasksForProject(project)}</strong> Total
																</div>
																<Graph100StackedBar data={project.graphData} onClick={this.onHundyPBarClick} />
															</div>
															{!this.props.isMobile && (
																<div className='col-4'>
																	{this.shouldShowMilestones(project) ? (
																		<Fragment>
																			<div className='task-title mb-2'>Milestones</div>
																			<div className='quick-links-container d-flex flex-wrap'>
																				{project.quickLinks.map((link, index, quickLinks) => {
																					// Determine classes and click handler
																					let quickLinkClass = 'quick-link d-flex align-items-center';
																					if (index + 1 !== quickLinks.length) {
																						quickLinkClass += ' border-end';
																					}
																					let clickHandler = this.onQuickLinkClick;
																					if (link.total === 0) {
																						quickLinkClass += ' text-muted';
																						clickHandler = () => {
																							/* Do nothing */
																						};
																					} else {
																						quickLinkClass += ' clickable';
																					}

																					// Retrieve UI link properties
																					const uiLink = QUICK_LINK_TYPES[link.type];
																					if (!uiLink) {
																						Notification(
																							'error',
																							'Error',
																							`Unsupported Quick Link Type found ${link.type}`
																						);
																						return null;
																					}
																					const title = uiLink.title;
																					const color = uiLink.color;

																					return (
																						<div
																							key={link.type}
																							className={quickLinkClass}
																							onClick={() => clickHandler(link.urlParams)}>
																							<span className='total me-2' style={{ color: color }}>
																								{link.total}
																							</span>
																							{title === QUICK_LINK_TYPES.PastDue.title ? (
																								<span className='title'>
																									Past
																									<br />
																									Due
																								</span>
																							) : (
																								<span className='title'>{title}</span>
																							)}
																						</div>
																					);
																				})}
																			</div>
																		</Fragment>
																	) : (
																		<Fragment></Fragment>
																	)}
																</div>
															)}
															{project.projectTagIds != undefined && (
																<div className='col-2'>
																	<div className='task-detail-section location-task-tags-section'>
																		<LabelTagDisplay
																			tags={this.props.projectTags}
																			tagIds={project.projectTagIds}
																		/>
																	</div>
																</div>
															)}
														</div>
													</div>
												</BarCard>
											</div>
										);
									})}
								</div>
							</div>
							{this.state.showMore && (
								<Button type='button' text='Show More' bootstrapClass='link' name='showMore' onClick={this.onShowMore} />
							)}
						</Fragment>
					) : (
						<div>There are no active projects for this location.</div>
					)}
					{this.isCustomerAdmin() && (
						<Button
							type='button'
							text='+ Add Project'
							bootstrapClass='link'
							name='addProject'
							onClick={this.openAddSingleLocProjectDrawer}
						/>
					)}

					<FileTypeIcon extension='.xlsx' />
					<Button
						type='button'
						text='Export Historical Projects'
						bootstrapClass='link'
						name='exportHistProjects'
						onClick={this.excelExport}
					/>

					<br />
				</LoadingIndicator>
				{this.state.isProjectResourcesDrawerOpen && (
					<ProjectsWidgetDrawer
						locationKey={this.props.locationKey}
						locationDashboardActions={this.props.locationDashboardActions}
						projectId={this.state.selectedProjectId}
						onComplete={this.onCompleteProjectResourcesDrawer}
						onCancel={this.onCancelProjectResourcesDrawer}
						isAdminRole={this.isCustomerAdmin()}
						onRequestWaiver={this.props.onRequestWaiver}
					/>
				)}

				{this.state.isAddSingleLocProjectDrawerOpen && this.isCustomerAdmin() && (
					<AddSingleLocProjectDrawer
						locationKey={this.props.locationKey}
						locationDashboardActions={this.props.locationDashboardActions}
						onComplete={this.onCompleteAddProjectDrawer}
						onCancel={this.onCancelAddProjectDrawer}
						currentUserId={this.props.currentUser.id}
					/>
				)}

				{this.state.isAddTaskForLocProjectDrawerOpen && this.isCustomerAdmin() && (
					<LocationTaskDetailDrawer
						task={this.state.task}
						isLoading={this.state.isLoading}
						filters={this.state.locationTaskDrawerFilters}
						responsibleUsers={this.state.locationUsers}
						userId={this.props.currentUser.id}
						onTaskChange={this.onTaskChange}
						locationTaskActions={this.props.locationTaskActions}
						filesActions={this.props.filesActions}
						showContingentDrawer={this.showContingentDrawer}
						showPrereqDrawer={this.showPrereqDrawer}
						onComplete={this.onLocationTaskDetailDrawerComplete}
						onCancel={this.onLocationTaskDetailDrawerCancel}
						isMobile={this.props.isMobile}
					/>
				)}
			</Fragment>
		);
	}
}

Projects.propTypes = {
	locationKey: PropTypes.string,
	subscriptionId: PropTypes.string.isRequired,
	locationDashboardActions: PropTypes.object.isRequired,
	isMobile: PropTypes.bool.isRequired,
	currentUser: PropTypes.object.isRequired,
	locationTaskActions: PropTypes.object.isRequired,
	filesActions: PropTypes.object,
	onRequestWaiver: PropTypes.func.isRequired,
	projectTags: PropTypes.array,
};

function mapDispatchToProps(dispatch) {
	return {
		locationTaskActions: bindActionCreators(locationTaskActions, dispatch),
		filesActions: bindActionCreators(filesActions, dispatch),
	};
}

function mapStateToProps(state) {
	return {
		windowWidth: state.window.width,
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(Projects);
